import axios from 'axios';
import { ImageModel, GenerateImageParams, GeneratedImage } from '../types';
import { removeWatermark, addRandomParam } from '../utils/imageProcessor';

// Pollinations.ai API基础URL
const BASE_URL = 'https://pollinations.ai/api';

// 模拟的模型数据 - 基于Pollinations.ai官方文档
const MODELS: ImageModel[] = [
  // 一、核心基础模型
  {
    id: 'flux',
    name: '通用写实风格',
    description: '通用写实风格模型，适合生成高质量的写实图像',
    capabilities: ['写实风格', '高质量', '通用场景'],
    previewImage: 'https://pollinations.ai/p/flux/gallery/1.jpg',
    tags: ['写实', '通用', '基础'],
    category: '核心基础模型'
  },
  {
    id: 'flux-pro',
    name: '专业写实风格',
    description: '高精度专业生成模型，提供更高质量和更好的细节',
    capabilities: ['超高清细节', '复杂场景', '精确控制'],
    previewImage: 'https://pollinations.ai/p/flux-pro/gallery/1.jpg',
    tags: ['高清', '细节', '专业'],
    category: '核心基础模型'
  },
  {
    id: 'stable-diffusion-v1-5',
    name: 'Stable Diffusion v1.5',
    description: '经典的Stable Diffusion v1.5模型，平衡性能与质量',
    capabilities: ['通用创作', '稳定输出', '经典模型'],
    previewImage: 'https://pollinations.ai/p/sd/gallery/1.jpg',
    tags: ['SD', '经典', '稳定'],
    category: '核心基础模型'
  },
  {
    id: 'stable-diffusion-xl',
    name: 'Stable Diffusion XL',
    description: 'Stable Diffusion的高级版本，提供更高质量和更好的细节',
    capabilities: ['高清细节', '复杂场景', '精确控制'],
    previewImage: 'https://pollinations.ai/p/sdxl/gallery/1.jpg',
    tags: ['SDXL', '高清', '高级'],
    category: '核心基础模型'
  },
  {
    id: 'mjv6-lora',
    name: 'Midjourney V6风格',
    description: 'Midjourney V6风格转译，适合梦幻和超现实风格',
    capabilities: ['梦幻风格', '超现实主义', '艺术构图'],
    previewImage: 'https://pollinations.ai/p/mjv6-lora/gallery/1.jpg',
    tags: ['梦幻', '艺术', '超现实'],
    category: '核心基础模型'
  },
  
  // 二、动漫与二次元专用
  {
    id: 'flux-anime',
    name: '标准动漫风格',
    description: '标准日式动漫风格，适合生成动漫角色和场景',
    capabilities: ['动漫角色', '日式风格', '二次元场景'],
    previewImage: 'https://pollinations.ai/p/flux-anime/gallery/1.jpg',
    tags: ['动漫', '二次元', '日式'],
    category: '动漫与二次元专用'
  },
  {
    id: 'any-dark',
    name: '暗黑系动漫',
    description: '暗黑系动漫风格，适合恐怖和黑暗题材',
    capabilities: ['恐怖风格', '黑暗氛围', '暗系动漫'],
    previewImage: 'https://pollinations.ai/p/any-dark/gallery/1.jpg',
    tags: ['暗黑', '恐怖', '动漫'],
    category: '动漫与二次元专用'
  },
  {
    id: 'jib-mix-flux',
    name: '混合动漫风格',
    description: '混合画风全能动漫，适合多种动漫风格融合',
    capabilities: ['多风格融合', '全能动漫', '风格多样'],
    previewImage: 'https://pollinations.ai/p/jib-mix-flux/gallery/1.jpg',
    tags: ['混合', '多风格', '动漫'],
    category: '动漫与二次元专用'
  },
  
  // 三、欧美卡通与3D风格
  {
    id: 'disney-lora',
    name: '迪士尼风格',
    description: '迪士尼卡通风格，适合生成迪士尼风格的角色和场景',
    capabilities: ['迪士尼角色', '卡通风格', '欢快氛围'],
    previewImage: 'https://pollinations.ai/p/disney-lora/gallery/1.jpg',
    tags: ['迪士尼', '卡通', '欧美'],
    category: '欧美卡通与3D风格'
  },
  {
    id: 'flux-pixar',
    name: '皮克斯3D风格',
    description: '皮克斯3D动画效果，适合生成3D卡通角色和场景',
    capabilities: ['3D效果', '皮克斯风格', '卡通角色'],
    previewImage: 'https://pollinations.ai/p/flux-pixar/gallery/1.jpg',
    tags: ['皮克斯', '3D', '卡通'],
    category: '欧美卡通与3D风格'
  },
  
  // 四、艺术与特殊效果
  {
    id: 'art-lora',
    name: '艺术绘画风格',
    description: '艺术绘画可商业设计，适合创意艺术和商业插画',
    capabilities: ['艺术绘画', '商业设计', '创意插画'],
    previewImage: 'https://pollinations.ai/p/art-lora/gallery/1.jpg',
    tags: ['艺术', '插画', '商业'],
    category: '艺术与特殊效果'
  },
  {
    id: 'dark-fantasy-flux',
    name: '暗黑幻想风格',
    description: '暗黑幻想生物场景，适合奇幻和黑暗题材',
    capabilities: ['暗黑氛围', '幻想生物', '奇幻场景'],
    previewImage: 'https://pollinations.ai/p/dark-fantasy-flux/gallery/1.jpg',
    tags: ['暗黑', '幻想', '奇幻'],
    category: '艺术与特殊效果'
  },
  {
    id: 'watercolor-lora',
    name: '水彩画风格',
    description: '水彩手绘效果，适合柔和艺术风格',
    capabilities: ['水彩效果', '手绘风格', '柔和色调'],
    previewImage: 'https://pollinations.ai/p/watercolor-lora/gallery/1.jpg',
    tags: ['水彩', '手绘', '艺术'],
    category: '艺术与特殊效果'
  }
  
  // 注：实用功能扩展类模型（如flux-fill, rmbg-2.0等）需要特殊处理，暂不添加到基本模型列表
];

// 获取可用的图像模型
export const fetchModels = async (): Promise<ImageModel[]> => {
  try {
    // 在实际应用中，应该从API获取模型列表
    // const response = await axios.get(`${BASE_URL}/models`);
    // return response.data;
    
    // 目前使用模拟数据
    return Promise.resolve(MODELS);
  } catch (error) {
    console.error('获取模型失败:', error);
    throw error;
  }
};

// 生成图像
export const generateImage = async (params: GenerateImageParams): Promise<GeneratedImage[]> => {
  try {
    // 处理参数
    const { model, prompt, negative_prompt = '', aspect_ratio = '1:1', quality = 'standard', seed, count = 1 } = params;
    
    // 生成随机种子，如果没有提供
    const actualSeed = seed || Math.floor(Math.random() * 10000000);
    
    // 根据宽高比计算实际宽高
    let baseSize = 1024; // 使用更高的基础分辨率
    let width = baseSize;
    let height = baseSize;
    
    // 根据宽高比计算实际宽高
    if (aspect_ratio) {
      const [w, h] = aspect_ratio.split(':').map(Number);
      
      if (w > h) {
        // 横向图像，保持宽度为基础尺寸
        width = baseSize;
        height = Math.round((h / w) * baseSize);
      } else if (h > w) {
        // 纵向图像，保持高度为基础尺寸
        height = baseSize;
        width = Math.round((w / h) * baseSize);
      } else {
        // 1:1比例保持正方形
        width = baseSize;
        height = baseSize;
      }
      
      // 确保宽高是偶数（某些AI模型要求）
      width = Math.floor(width / 2) * 2;
      height = Math.floor(height / 2) * 2;
    }
    
    // 根据质量调整分辨率
    if (quality === 'high') {
      width = Math.floor(width * 1.5);
      height = Math.floor(height * 1.5);
    } else if (quality === 'ultra') {
      width = Math.floor(width * 2);
      height = Math.floor(height * 2);
    }
    
    // 使用Pollinations.ai的正确API格式
    // 基础URL
    const baseUrl = 'https://image.pollinations.ai/prompt/';
    
    // 构建完整提示词
    let fullPrompt = prompt;
    
    // 添加模型参数 - 修复模型参数传递方式
    if (model) {
      switch (model) {
        // 核心基础模型
        case 'flux':
          fullPrompt = `flux ${fullPrompt}`;
          break;
        case 'flux-pro':
          fullPrompt = `flux-pro ${fullPrompt}`;
          break;
        case 'mjv6-lora':
          fullPrompt = `mjv6 ${fullPrompt}`; // 修正为正确的模型ID
          break;
        case 'stable-diffusion-v1-5':
          fullPrompt = `sd ${fullPrompt}`;
          break;
        case 'stable-diffusion-xl':
          fullPrompt = `sdxl ${fullPrompt}`;
          break;
          
        // 动漫与二次元专用
        case 'flux-anime':
          fullPrompt = `anime ${fullPrompt}`; // 修正为正确的动漫模型ID
          break;
        case 'any-dark':
          fullPrompt = `dark-anime ${fullPrompt}`; // 修正为正确的暗黑动漫模型ID
          break;
        case 'jib-mix-flux':
          fullPrompt = `anime-mix ${fullPrompt}`; // 修正为正确的混合动漫模型ID
          break;
          
        // 欧美卡通与3D风格
        case 'disney-lora':
          fullPrompt = `disney ${fullPrompt}`; // 修正为正确的迪士尼风格模型ID
          break;
        case 'flux-pixar':
          fullPrompt = `pixar ${fullPrompt}`; // 修正为正确的皮克斯风格模型ID
          break;
          
        // 艺术与特殊效果
        case 'art-lora':
          fullPrompt = `art ${fullPrompt}`; // 修正为正确的艺术绘画模型ID
          break;
        case 'dark-fantasy-flux':
          fullPrompt = `dark-fantasy ${fullPrompt}`; // 修正为正确的暗黑幻想模型ID
          break;
        case 'watercolor-lora':
          fullPrompt = `watercolor ${fullPrompt}`; // 修正为正确的水彩画模型ID
          break;
          
        // 兼容旧模型ID（为了向后兼容）
        case 'midjourney-style':
          fullPrompt = `mj ${fullPrompt}`; 
          break;
        case 'realistic-vision':
          fullPrompt = `realistic ${fullPrompt}`;
          break;
        case 'anime-style':
          fullPrompt = `anime ${fullPrompt}`; 
          break;
          
        // 默认使用flux模型
        default:
          fullPrompt = `flux ${fullPrompt}`;
          break;
      }
    }
    
    // 构建查询参数
    const queryParams: Record<string, string> = {
      width: width.toString(),
      height: height.toString(),
      seed: actualSeed.toString(),
      nologo: 'true',
      clean: 'true',
      no_watermark: 'true',
      signature: 'false',
      no_signature: 'true',
      cache: 'false',
      cachebuster: `${Date.now()}_${Math.floor(Math.random() * 1000000)}`
    };
    
    // 添加负面提示词（如果有）
    if (negative_prompt) {
      // 修复负面提示词的处理方式，使用正确的格式
      // 不使用URL路径拼接，而是使用标准的查询参数
      queryParams.negative = encodeURIComponent(negative_prompt);
    }
    
    // 构建查询字符串
    const queryString = Object.entries(queryParams)
      .map(([key, value]) => `${key}=${value}`)
      .join('&');
    
    // 构建最终URL - 使用Pollinations.ai的标准格式
    const finalImageUrl = `${baseUrl}${encodeURIComponent(fullPrompt)}?${queryString}`;
    
    // 输出生成的URL供调试
    console.log('生成的图片URL:', finalImageUrl);
    
    // 模拟API响应延迟
    await new Promise(resolve => setTimeout(resolve, 2000));
    
    // 创建生成的图像对象数组
    const generatedImages: GeneratedImage[] = [];
    
    for (let i = 0; i < count; i++) {
      // 为每张图片生成不同的随机种子
      const imageSeed = i === 0 ? actualSeed : Math.floor(Math.random() * 10000000);
      
      // 为每张图片创建不同的缓存控制参数
      const uniqueCacheBuster = `${Date.now()}_${Math.floor(Math.random() * 1000000)}_${i}`;
      
      // 为每张图片构建不同的查询参数
      const imageQueryParams = {
        ...queryParams,
        seed: imageSeed.toString(),
        cachebuster: uniqueCacheBuster
      };
      
      // 构建查询字符串
      const imageQueryString = Object.entries(imageQueryParams)
        .map(([key, value]) => `${key}=${value}`)
        .join('&');
      
      // 构建最终URL - 使用Pollinations.ai的标准格式
      const imageUrl = `${baseUrl}${encodeURIComponent(fullPrompt)}?${imageQueryString}`;
      
      // 输出生成的URL供调试
      console.log(`生成的图片${i+1} URL:`, imageUrl);
      
      const generatedImage: GeneratedImage = {
        id: `img_${Date.now()}_${Math.floor(Math.random() * 1000)}_${i}`,
        url: imageUrl,
        prompt: prompt,
        negative_prompt: negative_prompt || '', // 确保负面提示词不为undefined
        model: model,
        created_at: new Date().toISOString(),
        aspect_ratio: aspect_ratio,
        quality: quality,
        seed: imageSeed
      };
      
      generatedImages.push(generatedImage);
    }
    
    return generatedImages;
  } catch (error) {
    console.error('生成图像失败:', error);
    throw error;
  }
};

// 保存图像到本地
export const saveImageToLocal = async (imageUrl: string, filename: string): Promise<string> => {
  try {
    // 在浏览器环境中，我们可以使用Blob和URL.createObjectURL
    const response = await fetch(imageUrl);
    const blob = await response.blob();
    
    // 创建下载链接
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename || 'ai-painting.png';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    
    // 释放URL对象
    URL.revokeObjectURL(url);
    
    return filename;
  } catch (error) {
    console.error('保存图像失败:', error);
    throw error;
  }
};
